export const CROPPER_IMAGE_RATIO = 5 / 3

export const CROPPER_IMAGE_WIDTH = 1501
export const CROPPER_IMAGE_HEIGHT = 901

export const CROPPER_MIN_IMAGE_WIDTH = 600
export const CROPPER_MIN_IMAGE_HEIGHT = 360



/** WEBPACK FOOTER **
 ** ./src/constants/cropper-tool-constants.js
 **/